import classNames from 'classnames';
import { Link } from 'react-router-dom';

export const orderEditingPages = [
  {
    id: 'customization',
    label: 'Customization',
    description: 'Style your customer experience and preview your changes.',
    editable: true,
  },
  {
    id: 'rules',
    label: 'Editing rules',
    description: 'Choose which edits customers can make and for how long.',
    editable: true,
  },
  {
    id: 'shipping',
    label: 'Shipping offers',
    description:
      'Configure shipping options customers can request for their orders.',
    editable: true,
  },
  {
    id: 'requests',
    label: 'Requests',
    description: 'Review customer changes that need your approval.',
    editable: false,
  },
  {
    id: 'integrations',
    label: 'Integrations',
    description:
      'Connect order editing to your fulfillment and event workflows.',
    editable: false,
  },
  {
    id: 'activity',
    label: 'Usage & activity',
    description:
      'Review completed edits, usage charges and operational activity.',
    editable: false,
  },
] as const;

export type OrderEditingPage = (typeof orderEditingPages)[number]['id'];

export const orderEditingSettingsPages = orderEditingPages.filter(
  (page) => page.id === 'customization' || page.id === 'rules',
);

export const orderEditingPath = (page: OrderEditingPage) =>
  page === 'requests' || page === 'activity'
    ? `/order-editing/${page}`
    : `/settings/order-settings/${page}`;

export default function OrderEditingSettingsTabs({
  page,
}: {
  page: OrderEditingPage;
}) {
  return (
    <nav
      aria-label="Order editing settings sections"
      className="inline-flex w-full overflow-x-auto rounded-xl border border-gray-200 bg-white p-1.5 shadow-sm"
    >
      {orderEditingSettingsPages.map((tab) => (
        <Link
          key={tab.id}
          to={orderEditingPath(tab.id)}
          aria-current={page === tab.id ? 'page' : undefined}
          className={classNames(
            'inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-lg px-4 py-2 text-sm transition-all',
            page === tab.id
              ? 'bg-gray-100 font-semibold text-gray-900 shadow-sm'
              : 'font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700',
          )}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
